import { defineComponent as o, openBlock as t, createBlock as r, unref as v, mergeProps as d, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconCalendarWithCheck",
  __name: "IconCalendarWithCheck",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (c, e) => (t(), r(v(i), d(n, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M7.5 2.875a.75.75 0 0 1 .75.75v1.25h7.5v-1.25a.75.75 0 0 1 1.5 0v1.25h2.25a2.25 2.25 0 0 1 2.25 2.25v5.5a.75.75 0 0 1-1.5 0v-1.75H3.75v7.25a.75.75 0 0 0 .75.75H12a.75.75 0 0 1 0 1.5H4.5a2.25 2.25 0 0 1-2.25-2.25v-11a2.25 2.25 0 0 1 2.25-2.25h2.25v-1.25a.75.75 0 0 1 .75-.75m12.75 4.25v2.25H3.75v-2.25a.75.75 0 0 1 .75-.75h2.25v1.25a.75.75 0 0 0 1.5 0v-1.25h7.5v1.25a.75.75 0 0 0 1.5 0v-1.25h2.25a.75.75 0 0 1 .75.75",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M21 17.125a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.646-1.854a.5.5 0 0 1 0 .708l-2.447 2.446a1 1 0 0 1-1.414 0l-.847-.846a.5.5 0 0 1 .708-.708l.846.847 2.446-2.447a.5.5 0 0 1 .708 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
